/*eslint eqeqeq: "off"*/

export const sampleSeatsIds = [
  "S_407-A-1",
  "S_407-A-4",
  "S_407-A-5",
  "S_407-A-6",
  "S_407-A-7",
  "S_407-A-8",
  "S_407-A-9",
  "S_407-A-10",
  "S_407-A-11",
  "S_407-A-12",
  "S_407-A-13",
  "S_407-A-15",
  "S_407-A-16",
  "S_407-A-17",
  "S_407-A-18",
  "S_407-A-21",
  "S_407-B-2",
  "S_407-B-5",
  "S_407-B-8",
  "S_407-B-10",
  "S_407-N-31",
];
export const sectionIds = [
  {
    smid: "1",
    id: "DUGOUTBOXPREMIER",
    name: "Dugout Box Premier",
    sectionId: "1078",
  },
  { smid: "2", id: "DUGOUTBOX", name: "Dugout Box", sectionId: "1076" },
  { smid: "3", id: "INFIELDBOX", name: "Infield Box", sectionId: "1076" },
  { smid: "4", id: "BASELINEBOX", name: "Baseline Box", sectionId: "1091" },
  {
    smid: "5",
    id: "BASELINERESERVED",
    name: "Baseline Reserved",
    sectionId: "1256",
  },
  { smid: "6", id: "CORNER", name: "Corner", sectionId: "1267" },
  {
    smid: "7",
    id: "OUTFIELDRESERVED",
    name: "Outfield Reserved",
    sectionId: "1274",
  },
  {
    smid: "8",
    id: "CHAMPIONSCLUBMVP",
    name: "FIS Champions Club MVP",
    sectionId: "1115",
  },
  {
    smid: "9",
    id: "CHAMPIONSCLUB",
    name: "FIS Champions Club",
    sectionId: "1123",
  },
  { smid: "10", id: "MEZZANINE", name: "Mezzanine", sectionId: "1098" },
  { smid: "11", id: "GALLERY", name: "Gallery", sectionId: "1036" },
  { smid: "12", id: "UPPERGALLERY", name: "Upper Gallery", sectionId: "1205" },
  {
    smid: "15",
    id: "TERRACLUB",
    name: "Terra Club (All-Inclusive F&B)",
    sectionId: "1166",
  },
  {
    smid: "16",
    id: "PNCDIAMONDSEATS",
    name: "PNC Diamond Club (All-Inclusive F&B)",
    sectionId: "1212",
  },
];
export const mapSectoionStyles = [
  {
    section: {
      available: {
        normal: {
          none: {
            fillStyle: "#ba0c2f",
            strokeStyle: "#d44e69",
            "fill-opacity": 0.9,
            "stroke-opacity": 0,
            lineWidth: 0,
            opacity: 1,
            cursor: "auto",
            transition: "fill 0.5s, fill-opacity 0.5s",
          },
        },
        hover: {
          none: {
            fillStyle: "#ffacbf",
            strokeStyle: "#ba0c2f",
            "fill-opacity": 0.9,
            "stroke-opacity": 0,
            lineWidth: 0,
            cursor: "pointer",
            opacity: 1,
          },
        },
      },
      selected: {
        normal: {
          none: {
            fillStyle: "#ffacbf",
            strokeStyle: "#ba0c2f",
            "fill-opacity": 0.9,
            "stroke-opacity": 0,
            lineWidth: 0,
            cursor: "pointer",
            opacity: 1,
          },
        },
        hover: {
          none: {
            fillStyle: "#FFCCCC",
            strokeStyle: "#FF4D4D",
            "fill-opacity": 0.7,
            "stroke-opacity": 1,
            lineWidth: 1,
            cursor: "pointer",
            opacity: 1,
            transition: "fill 0.5s, fill-opacity 0.5s",
          },
        },
      },
      unavailable: {
        normal: {
          none: {
            fillStyle: "#fff",
            cursor: "auto",
            opacity: 0,
          },
        },
      },
      disabled: {
        normal: {
          none: {
            fillStyle: "#fff",
            cursor: "auto",
            opacity: 0,
          },
        },
      },
    },
    seat: {
      available: {
        normal: {
          none: {
            fillStyle: "#ba0c2f",
            strokeStyle: "#d44e69",
            lineWidth: 0.05,
            cursor: "pointer",
            opacity: 0.7,
          },
          restricted: {
            fillStyle: "#ba0c2f",
            strokeStyle: "#d44e69",
            lineWidth: 0.05,
            cursor: "pointer",
            opacity: 0.7,
            icon: "icon-restricted",
          },
          "visibility-reduced": {
            fillStyle: "#ba0c2f",
            strokeStyle: "#d44e69",
            lineWidth: 0.05,
            cursor: "pointer",
            opacity: 0.7,
            icon: "icon-restricted",
          },
          pending: {
            fillStyle: "#ba0c2f",
            strokeStyle: "#d44e69",
            lineWidth: 0.05,
            cursor: "not-allowed",
            opacity: 0.9,
            transition: "fill 0.5s, fill-opacity 0.5s",
          },
          disabled: {
            fillStyle: "#ba0c2f",
            strokeStyle: "#d44e69",
            lineWidth: 0.05,
            cursor: "pointer",
            opacity: 0.7,
            icon: "icon-disabled",
          },
          "social-distancing": {
            fillStyle: "#fff",
            strokeStyle: "#fff",
            lineWidth: 0.1,
            cursor: "pointer",
            opacity: 0.7,
            icon: "icon-social-distancing",
          },
        },
        hover: {
          none: {
            fillStyle: "#d44e69",
            strokeStyle: "#ba0c2f",
            lineWidth: 0.05,
            cursor: "pointer",
            opacity: 0.7,
          },
          "visibility-reduced": {
            fillStyle: "#d44e69",
            strokeStyle: "#ba0c2f",
            lineWidth: 0.05,
            cursor: "pointer",
            opacity: 0.7,
            icon: "icon-restricted",
          },
          restricted: {
            fillStyle: "#d44e69",
            strokeStyle: "#ba0c2f",
            lineWidth: 0.05,
            cursor: "pointer",
            opacity: 0.7,
            icon: "icon-restricted",
          },
          pending: {
            fillStyle: "#d44e69",
            strokeStyle: "#ba0c2f",
            lineWidth: 0.05,
            cursor: "not-allowed",
            opacity: 0.7,
            transition: "fill 0.5s, fill-opacity 0.5s",
          },
          disabled: {
            fillStyle: "#fff",
            opacity: 0,
            icon: "icon-disabled",
          },
          "social-distancing": {
            fillStyle: "#fff",
            strokeStyle: "#fff",
            lineWidth: 0.1,
            cursor: "pointer",
            opacity: 0.7,
            icon: "icon-social-distancing",
          },
        },
      },
      selected: {
        normal: {
          none: {
            fillStyle: "#FF4D4D",
            strokeStyle: "#801A1A",
            lineWidth: 0.05,
            cursor: "pointer",
            opacity: 0.7,
            icon: "icon-check",
          },
          restricted: {
            fillStyle: "#FF4D4D",
            strokeStyle: "#801A1A",
            lineWidth: 0.05,
            cursor: "pointer",
            opacity: 0.7,
            icon: "icon-check",
          },
          "visibility-reduced": {
            fillStyle: "#FF4D4D",
            strokeStyle: "#801A1A",
            lineWidth: 0.05,
            cursor: "pointer",
            opacity: 0.7,
            icon: "icon-check",
          },
          disabled: {
            fillStyle: "#FF4D4D",
            strokeStyle: "#801A1A",
            lineWidth: 0.05,
            cursor: "pointer",
            opacity: 0.7,
            icon: "icon-check",
          },
          "social-distancing": {
            fillStyle: "#fff",
            strokeStyle: "#fff",
            lineWidth: 0.1,
            cursor: "pointer",
            opacity: 0.7,
            icon: "icon-social-distancing",
          },
        },
        hover: {
          none: {
            fillStyle: "#FFCCCC",
            strokeStyle: "#FF4D4D",
            lineWidth: 0.05,
            cursor: "pointer",
            opacity: 0.7,
            icon: "icon-check",
          },
          restricted: {
            fillStyle: "#FFCCCC",
            strokeStyle: "#FF4D4D",
            lineWidth: 0.05,
            cursor: "pointer",
            opacity: 0.7,
            icon: "icon-restricted",
          },
          "visibility-reduced": {
            fillStyle: "#FFCCCC",
            strokeStyle: "#FF4D4D",
            lineWidth: 0.05,
            cursor: "pointer",
            opacity: 0.7,
            icon: "icon-restricted",
          },
          disabled: {
            fillStyle: "#fff",
            opacity: 0,
            icon: "icon-disabled",
          },
          "social-distancing": {
            fillStyle: "#fff",
            strokeStyle: "#fff",
            lineWidth: 0.1,
            cursor: "pointer",
            opacity: 0.7,
            icon: "icon-social-distancing",
          },
        },
      },
      unavailable: {
        normal: {
          "social-distancing": {
            fillStyle: "#fff",
            opacity: 0,
          },
        },
      },
    },
  },
];

// export function isTouch() {
//   return (
//     "ontouchstart" in window ||
//     navigator.maxTouchPoints > 0 ||
//     navigator.msMaxTouchPoints > 0
//   );
// }
const sectionIdsTdc3dd = {
  1078: "S_116",
  1080: "S_117",
  1068: "S_128",
  1070: "S_129",
  1074: "S_114",
  1076: "S_115",
  1066: "S_118",
  1067: "S_127",
  1072: "S_130",
  1089: "S_131",
  1224: "S_HP119",
  1223: "S_HP120",
  1222: "S_HP126",
  1256: "S_111",
  1258: "S_112",
  1261: "S_113",
  1091: "S_132",
  1093: "S_133",
  1096: "S_134",
  1267: "S_108",
  1254: "S_110",
  1083: "S_136",
  1084: "S_135",
  1085: "S_137",
  1268: "S_109",
  1270: "S_100",
  1271: "S_102",
  1272: "S_101",
  1274: "S_103",
  1275: "S_105",
  1276: "S_104",
  1263: "S_106",
  1265: "S_107",
  1087: "S_138",
  1107: "S_139",
  1105: "S_140",
  1111: "S_141",
  1109: "S_142",
  1110: "S_143",
  1113: "S_214",
  1114: "S_213",
  1115: "S_212",
  1119: "S_215",
  1121: "S_207",
  1127: "S_209",
  1128: "S_208",
  1125: "S_210",
  1116: "S_211",
  1117: "S_217",
  1118: "S_216",
  1014: "S_218",
  1015: "S_219",
  1016: "S_220",
  1123: "S_206",
  1009: "S_221",
  1104: "S_203",
  1101: "S_204",
  1102: "S_205",
  1012: "S_223",
  1007: "S_225",
  1002: "S_227",
  1100: "S_201",
  1098: "S_202",
  1022: "S_235",
  1031: "S_231",
  1025: "S_233",
  1030: "S_229",
  1034: "S_307",
  1063: "S_308",
  1061: "S_309",
  1057: "S_311",
  1055: "S_313",
  1056: "S_312",
  1051: "S_316",
  1052: "S_315",
  1053: "S_314",
  1049: "S_317",
  1190: "S_318",
  1192: "S_319",
  1041: "S_301",
  1042: "S_302",
  1040: "S_303",
  1038: "S_304",
  1036: "S_305",
  1033: "S_306",
  1059: "S_310",
  1195: "S_320",
  1197: "S_321",
  1201: "S_403",
  1202: "S_406",
  1200: "S_404",
  1204: "S_408",
  1205: "S_407",
  1206: "S_409",
  1208: "S_417",
  1209: "S_418",
  1210: "S_419",
  1211: "S_420",
  1207: "S_416",
  1203: "S_405",
  1166: "S_A",
  1165: "S_B",
  1164: "S_C",
  1162: "S_D",
  1161: "S_E",
  1212: "S_DC119",
  1213: "S_DC120",
  1214: "S_DC121",
  1215: "S_DC122",
  1216: "S_DC123",
  1218: "S_DC124",
  1220: "S_DC125",
  1221: "S_DC126",
  5761: "S_DCPATIO",
  1011: "S_222",
  1005: "S_224",
  1001: "S_226",
  1004: "S_228",
  1029: "S_230",
  1026: "S_232",
  1027: "S_234",
  1024: "S_236",
  1023: "S_237",
  1017: "S_238",
  1020: "S_239",
  1047: "S_240",
  1048: "S_241",
  1046: "S_242",
  1044: "S_243",
};

export const getSectionNameById = (id) => {
  const selectedSection = sectionIds.find((x) => x.id === id);

  if (selectedSection) {
    return selectedSection.name;
  } else {
    return id;
  }
};
export const getSectionObjById = (id) => {
  const selectedSection = sectionIds.find((x) => x.id === id);

  if (selectedSection) {
    return selectedSection;
  } else {
    return id;
  }
};
export const getSectionIdByName = (name) => {
  const selectedSection = sectionIds.find((x) => x.name === name);

  if (selectedSection) {
    return selectedSection.id;
  } else {
    return name;
  }
};
export const getSeatIdByRowNum = (seats, node) => {
  const seatSection = findTdcBy3dd(node.parent);
  const seatRow = node.row_id;
  const seatNumber = node.id.split("-")[2];

  return seats.filter(function (seat) {
    return (
      seat.seatNumber == seatNumber &&
      seat.row == seatRow &&
      seat.sectionId == seatSection
    );
  })[0];

  // if (selectedSection) {
  //   return selectedSection.id;
  // } else {
  //   return name;
  // }
};

export const getSeatRowNumById = ({ sectionId, row, seatNumber }) => {
  return `${sectionIdsTdc3dd[sectionId]}-${row}-${seatNumber}`;
};
// const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const mapAvailableSections = (availibleSections) => {
  return new Promise(async (resolve) => {
    const filteredArray = await availibleSections.map((section) => {
      return sectionIds[sectionIds.findIndex((x) => x.name === section.name)];
    });
    resolve(filteredArray);
  });
};

export function mapAllTdcTo3dd(seatsInfo, section) {
  const index = seatsInfo.findIndex(
    (x) => x.name === getSectionNameById(section)
  );

  return seatsInfo[index].sectionList?.map((x) => sectionIdsTdc3dd[x]);
}

export function mapTdcTo3dd(section) {
  return sectionIdsTdc3dd[section];
}

export function findTdcBy3dd(id) {
  return Object.keys(sectionIdsTdc3dd)[
    Object.values(sectionIdsTdc3dd).indexOf(id)
  ];
}

export const getSectionInfoById = (seatsInfo, id) => {
  return seatsInfo.filter((x) => x.name === getSectionNameById(id))[0];
};
